import { ModalProps, withModalConditionalRender } from '@billy/design-system'

import { MissingCompanyDetailsFormContextProvider } from './contexts/missingCompanyDetailsFormContext'
import { MissingCustomerDetailsFormContextProvider } from './contexts/missingCustomerDetailsFormContext'
import { MissingComplianceDetailsModalComponent } from './elements/MissingComplianceDetailsModalComponent'

interface MissingComplianceDetailsProps extends ModalProps {
  onConfirm: (() => void) | null
}

const MissingComplianceDetails = ({ onConfirm, ...modalProps }: MissingComplianceDetailsProps) => {
  return (
    <MissingCompanyDetailsFormContextProvider onConfirm={onConfirm}>
      <MissingCustomerDetailsFormContextProvider onConfirm={onConfirm}>
        <MissingComplianceDetailsModalComponent {...modalProps} />
      </MissingCustomerDetailsFormContextProvider>
    </MissingCompanyDetailsFormContextProvider>
  )
}

export const MissingComplianceDetailsModal = withModalConditionalRender(MissingComplianceDetails)
